import {ADD_USER_INFO, CLEAR_USER_INFO} from '../utils/ActionTypes';

const initialState = {premiseData: []};

const getUserInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_USER_INFO:
            return {...state, premiseData: action.payload};
        case CLEAR_USER_INFO:
            return{premiseData : []}
        default:
            return state; 
    }
};

export default getUserInfoReducer;